<div class="login-container">
	<div class="logo">
		<img src="assets/logos/serveox-logo-blue.svg" class="img-fluid" alt="ServeOx Logo" />
	</div>

	<h2 class="text-center">Login</h2>

	<app-google-signin></app-google-signin>

	<hr />

	<app-step-navigator [stepConfig]="navigationConfig" [(selectedStep)]="selectedStep"></app-step-navigator>

	<ng-container [ngSwitch]="selectedStep.switchCase">
		<ng-container *ngSwitchCase="AuthMethods.EMAIL">
			<form [formGroup]="emailLoginForm" class="form-container">
				<app-standard-control
					type="email"
					name="email"
					[formGroup]="emailLoginForm"
					label="Email Address"
					placeholder="Email Address"
					autocomplete="email"
				></app-standard-control>

				<app-password-control
					[formGroup]="emailLoginForm"
					name="password"
					label="Password"
					placeholder="Password"
					autocomplete="current-password"
				></app-password-control>

				<p class="text-center">
					<a class="text-decoration-none" [routerLink]="'../' + AuthRoutes.PASSWORD_RESET">Forgot Password?</a>
				</p>

				<button
					type="submit"
					class="btn btn-primary"
					[disabled]="emailLoginForm.invalid || emailLoginIsLoading"
					(click)="handleEmailLogin()"
				>
					<ng-container *ngIf="emailLoginIsLoading; else notLoading">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</ng-container>
					<ng-template #notLoading> Login </ng-template>
				</button>
			</form>
		</ng-container>

		<ng-container *ngSwitchCase="AuthMethods.PHONE_NUMBER">
			<form [formGroup]="phoneLoginForm" class="form-container">
				<app-phone-number-control [formGroup]="phoneLoginForm" name="phoneNumber"></app-phone-number-control>

				<ng-container *ngIf="verificationId">
					<app-alert
						[dismissible]="true"
						content="A verification code has been sent to your phone number. Please enter the code below to verify your number."
					></app-alert>
					<app-standard-control
						type="text"
						[formGroup]="phoneLoginForm"
						name="verificationCode"
						label="Verification Code"
						placeholder="Enter the verification code"
						labelPlacement="floating"
					></app-standard-control>
				</ng-container>

				<div class="button-container">
					<button type="button" class="btn btn-sm btn-outline-danger btn-width" (click)="handleResetPhoneForm()">Reset</button>

					<ng-container *ngIf="!verificationId">
						<button
							id="verificationCodeButton"
							type="button"
							[disabled]="verificationCodeLoading || phoneNumber.invalid || phoneNumber.pristine"
							class="btn btn-sm btn-primary btn-width"
							(click)="getVerificationCode()"
						>
							<ng-container *ngIf="verificationCodeLoading; else notLoading">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notLoading> Login </ng-template>
						</button>
					</ng-container>

					<ng-container *ngIf="verificationId">
						<button
							type="button"
							[disabled]="phoneLoginIsLoading || !verificationId || verificationCode.invalid || verificationCode.pristine"
							class="btn btn-sm btn-primary btn-width"
							(click)="handlePhoneNumberLogin()"
						>
							<ng-container *ngIf="phoneLoginIsLoading; else notSaving">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notSaving> Verify </ng-template>
						</button>
					</ng-container>
				</div>
			</form>
		</ng-container>
	</ng-container>

	<p class="text-center">
		Don't have an account yet? <a class="text-decoration-none" [routerLink]="'../' + AuthRoutes.SIGNUP">Sign up here.</a>
	</p>
</div>
